import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from 'reactstrap';
import FieldModal from '../../../../components/modals/fieldModal';
import API from '../../../../utils/API';

class InventoryRemoveSessionModal extends React.Component {
    state = {
        submitting: false
    };

    removeSessions = async () => {
        this.setState({ submitting: true });
        const { eventId, orgId, editedItem } = this.props;
        await API()
            .patch(`Organizations/${orgId}/events/${eventId}/inventory/${editedItem._id}`, {
                name: editedItem.name,
                bookedBy: Object.keys(this.props.checkedSessions),
                request: 'removeBookedBy'
            })
            .then((res) => {
                if (res.data) {
                    this.props.removeBookedBySessions(Object.keys(this.props.checkedSessions));
                    this.props.toggle();
                }
            });
    };


    render() {
        const { isOpen, toggle } = this.props;
        const { submitting } = this.state;
        const count = Object.keys(this.props.checkedSessions).length;
        return (

            <div>
                <FieldModal
                    size="small"
                    isOpen={isOpen}
                    modalTitle={"Remove Sessions"}
                    bodyHeaderText={<span>You are about to Remove{' '}
                        <b>
                            {count} session{count > 1 && 's'}
                        </b>{' '}
                        from this session, would you like to continue?</span>}
                    bodyContent={() => {
                        return ('')
                    }}
                    toggle={toggle}
                    actionButtonLabel={!submitting ? 'Remove' : 'Removing'}
                    actionButton={() => this.removeSessions()}
                    actionButtonDisabled={submitting}
                    isDelete={true}


                ></FieldModal>
            </div>

        );
    }
}

export default InventoryRemoveSessionModal;
